import { jsx as _jsx } from "react/jsx-runtime";
import { UploadContext } from "@air/component-upload-dropzone";
import { Uploads } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { memo, useCallback, useContext } from "react";
export const ContentCollectionCompletedUploadsButton = /*#__PURE__*/ memo(()=>{
    const { openUploader } = useContext(UploadContext);
    const _openUploader = useCallback(()=>{
        openUploader();
    }, [
        openUploader
    ]);
    return /*#__PURE__*/ _jsx(Button, {
        appearance: "filled",
        color: "blue",
        onClick: _openUploader,
        prefix: /*#__PURE__*/ _jsx(Uploads, {
            className: "size-4"
        }),
        size: "large",
        children: "Upload more"
    });
});
ContentCollectionCompletedUploadsButton.displayName = "ContentCollectionCompletedUploadsButton";
